import { useIsFocused } from "@react-navigation/native";
import React from "react";
import { StyleSheet, View } from "react-native";

const styles = StyleSheet.create({
  videoPreview: {
    marginTop: 10,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    overflow: "hidden",
    width: "100%",
    maxWidth: "100vw",
    maxHeight: "100vh",
    height: "auto",
    position: "relative",
    borderRadius: 4,
  },
  video: {
    width: "100%",
    height: "auto",
    position: "relative",
    borderRadius: 4,
  },
});

interface Props {
  video: any;
  videoRef: any;
  previewStream: any;
  audioRecord: any;
  isAudio: boolean;
}

const RecordPreview = ({
  video = "",
  previewStream,
  videoRef,
  audioRecord,
  isAudio,
}: Props) => {
  const isFocused = useIsFocused();

  return (
    <View style={styles.videoPreview}>
      {!!video && !isAudio && isFocused && (
        <video
          src={video}
          style={{
            width: "100%",
            height: "auto",
            position: "relative",
            borderRadius: 4,
          }}
          controls
        />
      )}
      {previewStream && !video && !isAudio && isFocused && (
        <video
          ref={videoRef}
          id="video-stream"
          style={{
            width: "100%",
            height: "auto",
            position: "relative",
            borderRadius: 4,
          }}
          autoPlay
        />
      )}
      {!!audioRecord && isFocused && (
        <audio
          id="audio"
          style={{ width: "100%" }}
          controls
          src={audioRecord}
        ></audio>
      )}
    </View>
  );
};

export default RecordPreview;
